import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import LandingPage from "@/pages/LandingPage";
import NotFound from "@/pages/NotFound";

export default function PathResolver() {
  const location = useLocation();
  const path = (location.pathname.toLowerCase().replace(/\/+$/, "") || "/");
  const [lp, setLp] = useState(() =>
    (window.__INITIAL_DATA__?.type === "landing" && window.__INITIAL_DATA__.payload?.url_path === path)
      ? window.__INITIAL_DATA__.payload : undefined);

  useEffect(() => {
    setLp((window.__INITIAL_DATA__?.type === "landing" && window.__INITIAL_DATA__.payload?.url_path === path)
      ? window.__INITIAL_DATA__.payload : undefined);
    let cancelled = false;
    const previewKey = new URLSearchParams(location.search).get("preview_key") || "";
    api
      .get("/public/landing", { params: { path, preview_key: previewKey } })
      .then((r) => { if (!cancelled) setLp(r.data); })
      .catch(() => { if (!cancelled) setLp(null); });
    return () => { cancelled = true; };
  }, [path, location.search]);

  if (lp === undefined) {
    return (
      <div className="min-h-[100vh] flex items-start justify-center pt-40" data-testid="path-resolver-loading">
        <Loader2 className="w-7 h-7 animate-spin text-slate-300" />
      </div>
    );
  }
  if (lp) return <LandingPage data={lp} />;
  return <NotFound />;
}
